export default "__VITE_ASSET__fp2s8utU__"